export default {"src":"/_next/static/media/male_2.15b1f7af.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};